const STATUS = {
  INITIALIZE: 0,
  PROCESSING: 1,
  COMPLETED: 2,
  CANCELLED: 3,
  ERROR: 9,
};

export default Object.freeze({
  STATUS,
  DONE_STATUS_LIST: [STATUS.COMPLETED, STATUS.CANCELLED, STATUS.ERROR],
});
